import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import * as s from "./GalleryGridColumn.module.scss";

type GalleryGridColumnProps = PropsWithChildren<{
	offset?: boolean;
}>;

const GalleryGridColumn: FC<GalleryGridColumnProps> = ({
	children,
	offset = false,
}) => {
	return (
		<div className={cn(s.galleryGridColumn, { [s.offset]: offset })}>
			{children}
		</div>
	);
};

export default GalleryGridColumn;
